import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppProviders } from "./AppProviders";
import { Route } from "react-router";
import { AdminMode } from "./Admin";
import HomeScreen from './HomeScreen';
import {Privacy} from "./Privacy";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <React.StrictMode>
    <AppProviders>
      <Route path="/" element={<App />} />
      <Route path="/rules" element={<HomeScreen />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/449de4712de7eb7c07e2613f6581fd57" element={<AdminMode />} />
    </AppProviders>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
